import { useFetchBoardQuery } from '@api/Trinium/Endpoints/BoardQueries/slice';
import { defaultAllOpenQuery, isActiveQuery } from '@api/Trinium/Endpoints/BoardQueries/types';
import { BoardQuery } from '@api/Trinium/types';

interface DispatchBoardQueries {
  defaultQuery: BoardQuery | undefined;
  currentQuery: BoardQuery;
}

/**
 * Single subscription to the Board Queries endpoint that resolves both the
 * tenant's default query and the query currently selected by the user. Used by
 * both Grid and MobileGrid to avoid duplicate RTK Query subscriptions firing
 * their own selectFromResult on every cache update.
 */
export default function useDispatchBoardQueries(
  terminalNumber: number | string | undefined,
  selectedBoardQueryName: string | undefined
): DispatchBoardQueries {
  return useFetchBoardQuery(String(terminalNumber), {
    selectFromResult: ({ data }): DispatchBoardQueries => ({
      defaultQuery: data?.find((qry) => qry.isDefault && isActiveQuery(qry)),
      currentQuery: data?.find((q) => q.name === selectedBoardQueryName && isActiveQuery(q)) ?? defaultAllOpenQuery
    })
  });
}
